import React from 'react'
import classes from './button.module.scss';

const Button = ({label, white, fullWidth = false, type = 'button', onClick}) => {
  return (
    <button type={type} style={fullWidth ? { width: '100%' } : null} className={`${classes.btn} ${white ? classes.btn__white : null}`} onClick={onClick}>
        <span>{label}</span>
    </button>
  )
}

export default Button